import {
  SR_API_ACTION_HOUSEHOLD_APPLICATION_PROCESS_CHARGE,
} from 'api/actionTypes';

export default async function processCharge(
  { state, apiClient },
  { householdApplicationId, listingId, source }
) {
  return apiClient.postWithState({
    action: SR_API_ACTION_HOUSEHOLD_APPLICATION_PROCESS_CHARGE,
    state: state,
    payload: {
      source,
      listingId,
      householdApplicationId,
    },
  });
}
